import React from 'react';

import Feature from '../../../components/_common/Feature';

import './articles.scss';

export default class TheBreweryArticles extends React.Component {
  render () {
    const { items } = this.props

    return (
      <div className='brewery-articles2'>
        {items &&
          items.map((item, index) => {
            return (
              <Feature
                key={`brewery-article_${index}`}
                className='feature brewery-articles__article'
                article={item}
                reverse={index % 2 === 0}
                colReverse
                noGutters
                index={index}
              />
            )
          })}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/brewery/Articles/index.js